import React from 'react';
import usePodcastImages from 'hooks/usePodcastImages';
import AddThisSocialSharing from 'components/AddThisSocialSharing';
import { WebsiteImage } from 'components/TitleDescription';
import SounderPlayer from '../SounderPlayer';
import { SectionContainer } from './styles';

const PodcastDetailHeroSection = ({
  backgroundColor,
  episode,
  subTitle,
  title,
  created_date,
  coverPhoto,
  episodeId,
  pageUrl,
  ...otherProps
}) => {
  const data = usePodcastImages();
  let podcastHero = data[0].node.image?.file.url;
  let podcastMark = data[1].node.image?.file.url;

  return (
    <SectionContainer backgroundColor={backgroundColor} {...otherProps}>
      <div className="section-podcast-detail-hero--wrapper">
        <div className="section-podcast-detail-hero--container">
          <div className="section-podcast-detail-hero--main-container">
            <div className="section-podcast-detail-hero--image-side">
              <div className="section-podcast-detail-hero--image-container">
                <WebsiteImage
                  className="section-podcast-detail-hero--image"
                  src={coverPhoto?.image || podcastHero}
                />
                <img className="section-podcast-detail-hero--mark" src={podcastMark} />
              </div>
            </div>
            <div className="section-podcast-detail-hero--text-side">
              <p className="section-podcast-detail-hero--subtitle">{subTitle}</p>
              <h2 className="section-podcast-detail-hero--title">{title}</h2>
              <p className="section-podcast-detail-hero--date">{created_date}</p>
              <AddThisSocialSharing placement="mobile" pageUrl={pageUrl} />
              {episodeId && <SounderPlayer episodeId={episodeId} />}
            </div>
          </div>
        </div>
      </div>
    </SectionContainer>
  );
};

export default PodcastDetailHeroSection;
